import * as React from 'react';
const List = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-list", ...props },
    React.createElement("line", { x1: "8", y1: "6", x2: "21", y2: "6" }),
    React.createElement("line", { x1: "8", y1: "12", x2: "21", y2: "12" }),
    React.createElement("line", { x1: "8", y1: "18", x2: "21", y2: "18" }),
    React.createElement("line", { x1: "3", y1: "6", x2: "3", y2: "6" }),
    React.createElement("line", { x1: "3", y1: "12", x2: "3", y2: "12" }),
    React.createElement("line", { x1: "3", y1: "18", x2: "3", y2: "18" })));
export default List;
//# sourceMappingURL=List.js.map